import { Box, styled } from "@mui/material";

export const Label = styled(Box)({
  fontWeight: 500,
  letterSpacing: 0.5,
});
